
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import FormInputField from '@/components/block/FormInputField.vue'
import CheckboxButton from '@/components/elements/InputCheckboxButton.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import Button from '@/components/elements/Button.vue'
import axios from 'axios'

export default {
  components: {
    FormInputField,
    CheckboxButton,
    GoalButtons,
    Button
  },

  setup() {
    const state = reactive<{
      email: string
      isError: boolean
      errorMessage: string
      isErrorAgree: boolean
    }>({
      email: '',
      isError: false,
      errorMessage: '',
      isErrorAgree: false
    })

    const agree_flg = ref(false)

    const changeMessage = (name: string, value: string) => {
      state.email = value
    }

    const changeFlg = (target: string, ev: any) => {
      agree_flg.value = ev.checked
    }

    const csrf = ref(
      document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')
    )
    const router = useRouter()

    const sendConfirm = async () => {
      try {
        if (!agree_flg.value) {
          alert('入力に誤りがあります')
          state.isErrorAgree = true
          return true
        }

        await axios.post('/api/v1/start_use/email', {
          email: state.email,
          csrf: csrf
        })
        router.push('/procedure/send/')
      } catch (errors) {
        alert('入力に誤りがあります')

        const errorInfo = errors.response.data
        Object.keys(errorInfo).forEach((key) => {
          state.isError = true
          state.errorMessage = errorInfo[key].join()
        })
      }
    }
    return {
      state,
      sendConfirm,
      changeMessage,
      agree_flg,
      changeFlg,
      csrf
    }
  }
}
